module.exports = __webpack_public_path__ + "img/yyqx.1e5b9b96.jpg";